export default __webpack_public_path__ + "static/media/user_list.c2a5b84d.svg";